import { SearchPlant, DATA_PAGINATION, Plant } from '@/types'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

export const plantApi = {
  getAll(searchParams: SearchPlant) {
    const url = '/api/plant'
    return axiosClient.get<DATA_PAGINATION<Plant>>(url + queryStringify(searchParams))
  }
}

export default plantApi
